<dhofar-shared-sidebar 
  [sidebarItems]="sidebarItems" 
  [user]="user" 
  [roleCode]="roleCode"
  (onSignOut)="handleSignOut()"
  (onThemeToggle)="handleThemeToggle()">
</dhofar-shared-sidebar>
